<button
  type="button"
  (click)="userMenu.toggle($event)"
  class="flex items-center flex-shrink-0 gap-3 px-2 py-1 transition-colors rounded-lg hover:bg-white/5 group border-none bg-transparent"
>
  <!-- Iniciais do Usuário (Apenas Mobile) -->
  <div
    class="lg:hidden flex items-center justify-center w-10 h-10 rounded-full bg-blue-800 border border-white/10 text-white text-sm font-bold"
  >
    {{ userInitials }}
  </div>

  <!-- Informações do Usuário (Nome e Email empilhados - Desktop) -->
  <div class="hidden flex-col items-start lg:flex text-left">
    <span class="text-sm font-semibold text-white leading-tight mb-0.5">
      {{ userName }}
    </span>
    <span class="text-[12px] font-normal text-bluegray-400 leading-tight">
      {{ currentUser?.email || 'email@exemplo.com' }}
    </span>
  </div>

  <!-- Ícone de Seta (Apenas Desktop) -->
  <i
    class="hidden pi pi-chevron-down text-[10px] text-bluegray-400 lg:block group-hover:text-white transition-colors ml-1"
  ></i>
</button>

<p-menu
  #userMenu
  [popup]="true"
  [model]="userMenuItems"
  appendTo="body"
></p-menu>
